import { application } from "./application"

import AiAssistantController from "./ai_assistant_controller"
import AutohideController from "./autohide_controller"
import BlockEditorController from "./block_editor_controller"
import BoardColumnController from "./board_column_controller"
import BulkSelectController from "./bulk_select_controller"
import CalendarController from "./calendar_controller"
import ChartController from "./chart_controller"
import ClearOnSubmitController from "./clear_on_submit_controller"
import ClipboardController from "./clipboard_controller"
import CloneOptionsController from "./clone_options_controller"
import ClockController from "./clock_controller"
import CollapsibleController from "./collapsible_controller"
import RememberedDetailsController from "./remembered_details_controller"
import ComboboxController from "./combobox_controller"
import CommandPaletteController from "./command_palette_controller"
import ConfirmMatchController from "./confirm_match_controller"
import DialogMessagesController from "./dialog_messages_controller"
import DocumentPresenceController from "./document_presence_controller"
import DraftAutosaveController from "./draft_autosave_controller"
import FavoritesReorderController from "./favorites_reorder_controller"
import StatesReorderController from "./states_reorder_controller"
import NotesReorderController from "./notes_reorder_controller"
import StickiesReorderController from "./stickies_reorder_controller"
import PagesReorderController from "./pages_reorder_controller"
import SidebarFavoritesController from "./sidebar_favorites_controller"
import SidebarScrollController from "./sidebar_scroll_controller"
import MainScrollController from "./main_scroll_controller"
import SidebarFoldersController from "./sidebar_folders_controller"
import AppSidebarController from "./app_sidebar_controller"
import PaletteSwatchesController from "./palette_swatches_controller"
import FilterMenuController from "./filter_menu_controller"
import GanttController from "./gantt_controller"
import GanttSpotlightController from "./gantt_spotlight_controller"
import HelpSearchController from "./help_search_controller"
import ImportProgressController from "./import_progress_controller"
import InlineEditController from "./inline_edit_controller"
import KanbanController from "./kanban_controller"
import LazyRevealController from "./lazy_reveal_controller"
import ListFilterController from "./list_filter_controller"
import LoadMoreController from "./load_more_controller"
import LoadedRowsController from "./loaded_rows_controller"
import FileDropController from "./file_drop_controller"
import MentionAutocompleteController from "./mention_autocomplete_controller"
import MermaidController from "./mermaid_controller"
import ModalController from "./modal_controller"
import OwnerPickerController from "./owner_picker_controller"
import WorkItemPickerController from "./work_item_picker_controller"
import PeekController from "./peek_controller"
import ErrorPeekController from "./error_peek_controller"
import PopoverController from "./popover_controller"
import PushSubscriptionController from "./push_subscription_controller"
import PwaController from "./pwa_controller"
import SelectionToItemController from "./selection_to_item_controller"
import TableScrollController from "./table_scroll_controller"
import ShortcutsController from "./shortcuts_controller"
import StickyController from "./sticky_controller"
import TemplatePickerController from "./template_picker_controller"
import ThemeController from "./theme_controller"
import ToastLayerController from "./toast_layer_controller"
import TruncateController from "./truncate_controller"
import AutoSubmitController from "./auto_submit_controller"
import AutogrowController from "./autogrow_controller"
import ScheduleFieldsController from "./schedule_fields_controller"
import PrintController from "./print_controller"
import FrameRevealController from "./frame_reveal_controller"
import DropdownLoadController from "./dropdown_load_controller"
import SuggestionController from "./suggestion_controller"
import StatusComponentsReorderController from "./status_components_reorder_controller"
import DensityController from "./density_controller"
import MenuActionsController from "./menu_actions_controller"
import ListSubItemsController from "./list_sub_items_controller"
import ListSubItemsPreferenceController from "./list_sub_items_preference_controller"
import WidgetFormController from "./widget_form_controller"
import FeatureTourController from "./feature_tour_controller"
import ProductTourController from "./product_tour_controller"

application.register("ai-assistant", AiAssistantController)
application.register("autohide", AutohideController)
application.register("block-editor", BlockEditorController)
application.register("bulk-select", BulkSelectController)
application.register("calendar", CalendarController)
application.register("chart", ChartController)
application.register("clear-on-submit", ClearOnSubmitController)
application.register("clipboard", ClipboardController)
application.register("clone-options", CloneOptionsController)
application.register("clock", ClockController)
application.register("collapsible", CollapsibleController)
application.register("remembered-details", RememberedDetailsController)
application.register("combobox", ComboboxController)
application.register("command-palette", CommandPaletteController)
application.register("confirm-match", ConfirmMatchController)
application.register("dialog-messages", DialogMessagesController)
application.register("document-presence", DocumentPresenceController)
application.register("draft-autosave", DraftAutosaveController)
application.register("favorites-reorder", FavoritesReorderController)
application.register("states-reorder", StatesReorderController)
application.register("notes-reorder", NotesReorderController)
application.register("stickies-reorder", StickiesReorderController)
application.register("pages-reorder", PagesReorderController)
application.register("sidebar-favorites", SidebarFavoritesController)
application.register("sidebar-scroll", SidebarScrollController)
application.register("main-scroll", MainScrollController)
application.register("sidebar-folders", SidebarFoldersController)
application.register("app-sidebar", AppSidebarController)
application.register("palette-swatches", PaletteSwatchesController)
application.register("filter-menu", FilterMenuController)
application.register("gantt", GanttController)
application.register("gantt-spotlight", GanttSpotlightController)
application.register("help-search", HelpSearchController)
application.register("list-filter", ListFilterController)
application.register("import-progress", ImportProgressController)
application.register("inline-edit", InlineEditController)
application.register("board-column", BoardColumnController)
application.register("kanban", KanbanController)
application.register("lazy-reveal", LazyRevealController)
application.register("load-more", LoadMoreController)
application.register("loaded-rows", LoadedRowsController)
application.register("file-drop", FileDropController)
application.register("mention-autocomplete", MentionAutocompleteController)
application.register("mermaid", MermaidController)
application.register("modal", ModalController)
application.register("owner-picker", OwnerPickerController)
application.register("work-item-picker", WorkItemPickerController)
application.register("peek", PeekController)
application.register("error-peek", ErrorPeekController)
application.register("popover", PopoverController)
application.register("push-subscription", PushSubscriptionController)
application.register("pwa", PwaController)
application.register("selection-to-item", SelectionToItemController)
application.register("table-scroll", TableScrollController)
application.register("shortcuts", ShortcutsController)
application.register("sticky", StickyController)
application.register("template-picker", TemplatePickerController)
application.register("theme", ThemeController)
application.register("toast-layer", ToastLayerController)
application.register("truncate", TruncateController)
application.register("auto-submit", AutoSubmitController)
application.register("autogrow", AutogrowController)
application.register("schedule-fields", ScheduleFieldsController)
application.register("print", PrintController)
application.register("frame-reveal", FrameRevealController)
application.register("dropdown-load", DropdownLoadController)
application.register("suggestion", SuggestionController)
application.register("status-components-reorder", StatusComponentsReorderController)
application.register("density", DensityController)
application.register("menu-actions", MenuActionsController)
application.register("list-sub-items", ListSubItemsController)
application.register("list-sub-items-preference", ListSubItemsPreferenceController)
application.register("widget-form", WidgetFormController)
application.register("feature-tour", FeatureTourController)
application.register("product-tour", ProductTourController)
